var map = {
	"./Attendees.jpg": 778,
	"./DSCF5049.JPG": 484,
	"./Eid Al Adha Grill Event 24072022.JPG": 694,
	"./Eid Al Fitr 2022.HEIC.jpeg": 977,
	"./Eid Ul Adha 2022 Kids.jpg": 539,
	"./Eid Ul Adha 2022.jpg": 422,
	"./HMD group photo.jpg": 921,
	"./Iftaar-01.jpg": 552,
	"./Iftaar-02.jpg": 775,
	"./Iftaar-03.jpg": 314,
	"./Iftaar-04.jpg": 801,
	"./Iftaar-05.jpg": 428,
	"./Iftaar-06.jpg": 227,
	"./Presentation.jpg": 99,
	"./photo_2021-09-25_19-22-37.jpg": 46,
	"./photo_2022-03-09_03-58-01.jpg": 112,
	"./photo_2022-06-16_17-47-41.jpg": 662,
	"./photo_2023-02-22_19-42-41.jpg": 315,
	"./photo_2023-02-22_19-42-49.jpg": 851,
	"./photo_2023-02-22_19-42-57.jpg": 702,
	"./photo_2023-02-22_19-43-29.jpg": 534,
	"./photo_2023-02-22_19-55-23.jpg": 231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;